import './styles/index.scss';

import { ConfigProvider } from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import App from './App';
import './i18n';
import { store } from './store';

const rootEl = document.getElementById('root');
if (rootEl) {
  const helmetContext = {};

  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ConfigProvider locale={ruRU}>
          <HelmetProvider context={helmetContext}>
            <Helmet titleTemplate="Nomad / %s" defaultTitle="Nomad" />
            <App />
          </HelmetProvider>
        </ConfigProvider>
      </Provider>
    </React.StrictMode>
  );
}
